



















import { Component, Vue, Watch } from 'vue-property-decorator';
import {Actions, Mutations, ViewModes, Views} from '@/ts/store/Constants';
import Modal from '@/components/Modal/Modal.vue';
import ChatBody from '@/components/Chat/ChatBody.vue';
import ChatMessageInput from '@/components/Chat/ChatMessageInput.vue';
import DeleteMessageAction from '@/components/Overlays/Actions/MessageActions/DeleteMessageAction.vue';
import DashboardNotification from '@/ts/instances/notifications/DashboardNotification';

@Component({
    components: {
        Modal,
        ChatBody,
        ChatMessageInput,
        DeleteMessageAction,
    },
})
export default class CommentsOverlayMobile extends Vue {
    public showMessageActions: boolean = false;
    public activeMessage: any = null;

    get activeNotification(): DashboardNotification {
        return this.$store.getters['TenantNotifications/getActiveNotification'];
    }

    get comments() {
        return this.$store.getters['Comments/getComments'];
    }

    get commentsLoaded() {
        return this.$store.getters['Comments/getCommentsDataLoaded'];
    }

    @Watch('commentsLoaded')
    public commentsAreLoaded() {
        Vue.nextTick(() => {
            this.scrollToBottom();
        });
    }

    public handleSendMessage(message: string) {
        const commentData: any = {
            conversationId: this.comments.id,
            message,
            notificationId: this.comments.notification_id,
        };

        if (this.activeNotification.eventId) {
            commentData.eventId = this.activeNotification.eventId;
        }

        this.$store.dispatch(Actions.ADD_COMMENT, commentData)
            .then(() => {
                this.scrollToBottom();
            });
    }

    public openMessageActions(message: any) {
        this.activeMessage = message;
        this.showMessageActions = true;
    }

    public closeMessageActions() {
        this.activeMessage = null;
        this.showMessageActions = false;
    }

    public deleteMessage() {
        this.$store.dispatch(Actions.REMOVE_COMMENT, this.activeMessage)
            .then(() => {
                this.closeMessageActions();
            });
    }

    public scrollToBottom(): void {
        const scrollElement = document.getElementById('hoc-modal-body');
        scrollElement.scrollTo(0, scrollElement.scrollHeight);
    }

    public goBack() {
        if (!this.activeNotification.eventId) {
            this.$store.commit(Mutations.SET_VIEW, {
                view: Views.Notifications,
                viewMode: ViewModes.Notifications.InformationView,
            });

            this.$router.push({
                name: 'notification',
                params: { notificationId: this.activeNotification.id.toString() },
            });
        } else {
            this.$router.push({
                name: 'event',
                params: { eventId: this.activeNotification.eventId.toString() },
                query: { notification: this.activeNotification.id.toString() },
            });
        }

        this.closeOverlay();
    }

    public closeOverlay() {
        this.$store.dispatch(Actions.CLOSE_COMMENTS_SOCKET, {vue: this, conversationId: this.comments.id});
        this.$store.commit(Mutations.SET_COMMENTS_OVERLAY_VISIBILITY, false);
    }
}
